import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { injectContentsquareScript } from "@contentsquare/tag-sdk";

// Initialize Contentsquare analytics
injectContentsquareScript({
  siteId: "6434264",
  async: true, // Optional: Set to false to wait for script execution until after document parsing.
  defer: false, // Optional: Set to true to defer script execution after document parsing.
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
